module.exports = "<kt-subheader2\n  *ngIf=\"layout === 'subheader-v2'\"\n  [fluid]=\"fluid\"\n  [clear]=\"clear\"\n></kt-subheader2>\n"